<template>
    <div style="margin-bottom: 140px">
        <div style="margin-bottom: 14px;text-align: left">
            <div class="page-title">
                Мапа доставки
            </div>
        </div>

        <div>
            <iframe v-if="iframeSrc" :src="iframeSrc" style="width: 100%; height: 500px"></iframe>

            <span v-if="!iframeSrc" style="color: #AB2321">Нажаль, для Вашого міста мапа недоступна</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeSrc: '',
        }
    },
    mounted() {
        this.iframeSrc = '/html/delivery-map/' + this.$route.params.locationCity + '.html';
    }
}
</script>
